<template>
    <select-component
      v-if="categoriesToDisplay.length"
      :options-list="categoriesToDisplay"
      :selectedValue="category"
      :prop-for-value="$options.compareFieldName"
      @update:selectedValue="categoryUpdate"
      class="d-flex cw-category-filter align-items-center gap-1"
    >
      <template v-slot:label>
        <div class="cw-category-filter__title p-2 d-flex align-items-center">
          <span>{{ $t('Sport') }}</span>
        </div>
      </template>
      <template v-slot:default="{option}">
        <div class="d-inline-flex justify-content-between w-100 px-2">
          <span>{{ $t(option[$options.displayFieldName]) }}</span>
          <favorite-star-toggle
            v-if="option.id"
            :favorite="option"
            :type="$options.TYPE"
            class="cw-fav-toggle"
          />
        </div>
      </template>
    </select-component>
</template>

<script>
import SelectComponent from './customSelect/SelectComponent';
import {mapActions, mapState} from 'vuex';
import {GET_EVENT_CATEGORIES} from '@/store/actionTypes';
import {FAVORITE_TYPES, URL_QUERIES} from '@/const';
import {updateRouteQuery} from '@/utils/helpers';
import FavoriteStarToggle from '@/components/favorites/FavoriteStarToggle';

export default {
  name: 'CategoryFilter',
  components: {
    SelectComponent,
    FavoriteStarToggle,
  },
  TYPE: FAVORITE_TYPES.category,
  compareFieldName: 'alias',
  displayFieldName: 'name',
  data() {
    return {
      category: this.$route.query[URL_QUERIES.category] ?? '',
    };
  },
  watch: {
    async $route() {
      await this.$nextTick();
      this.category = this.$route.query[URL_QUERIES.category];
    },
    categoryData() {
      updateRouteQuery(
          this.$route,
          this.$router,
          URL_QUERIES.category,
          this.categoryData?.[this.$options.compareFieldName],
      );
      this.$emit('update:category', this.categoryData);
    },
  },
  methods: {
    ...mapActions({
      getCategories: GET_EVENT_CATEGORIES,
    }),
    clear() {
      this.category = null;
    },
    categoryUpdate(category) {
      this.category = category?.[0]?.[this.$options.compareFieldName];
    },
  },
  computed: {
    ...mapState({
      categories: (state) => state.event.eventCategories || [],
      flattenCategories: (state) => Object.values(state.event.eventCategoriesById || {}),
    }),
    categoryData() {
      return this.flattenCategories?.find((category) => {
        return this.category === category?.[this.$options.compareFieldName];
      });
    },
    categoriesToDisplay() {
      const arr = [];
      const cb = (category, displayableArr) => {
        if (category.is_displayable) {
          const arr = [];
          category.children?.forEach((cat) => cb(cat, arr));
          displayableArr.push({
            ...category,
            children: arr,
          });
        } else {
          category.children?.forEach((cat) => cb(cat, displayableArr));
        }
      };
      this.categories.forEach((category) => cb(category, arr));
      return arr;
    },
  },
  mounted() {
    this.getCategories();
    this.$emit('interface', {
      clear: this.clear,
    });
  },
};
</script>
<style lang="scss" scoped>
.cw-category-filter {
  --border-color: var(--settings-footer-background-20);
  border: 1px solid var(--settings-footer-background-50);
  border-radius: .3rem;
}

.cw-category-filter__title {
  background: var(--settings-body-text-color-50);
  height: 100%;
}
.cw-fav-toggle{
  min-height: 1.7rem;
}
</style>
